import { Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay } from '@chakra-ui/modal';
import { Button, Flex, useDisclosure, ModalHeader, ModalCloseButton } from '@chakra-ui/react';
import React from 'react';
import { activeOrInactiveLawyer } from 'services/lawyers';
import { colors } from 'theme/colors';
import { openNotification } from 'utils/notification';

interface IProps {
  demand: any;
  setUpdate: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ComponentModalChangeStatus: React.FC<IProps> = ({ demand, setUpdate }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleUpdateStatus = async (data: { id: number; name: string; status: boolean }) => {
    try {
      await activeOrInactiveLawyer({
        id: Number(data.id),
        name: data.name,
        status: !data.status,
      });
      setUpdate(oldState => !oldState);
      openNotification('Status do advogado alterado com sucesso!', 'success');
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Flex
        onClick={onOpen}
        // onClick={() => handleUpdateStatus(demand)}
        color="white"
        justify="center"
        borderRadius="500px"
        paddingBlock="4px"
        bg={demand?.status ? colors.brand.green500 : colors.brand.red200}
      >
        {demand?.status ? 'Ativo' : 'Inativo'}
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent width="20rem">
          <ModalHeader color={colors.brand.gray600} fontWeight="700">
            {!demand?.status ? 'Ativar Advogado' : 'Inativar Advogado'}
          </ModalHeader>

          <ModalBody color="#000">
            {demand?.status
              ? 'Ao inativar um advogado, este não aparecerá mais na lista de advogados em solicitações.'
              : 'Ao ativar um advogado, este aparecerá na lista de advogados em solicitações.'}
          </ModalBody>

          <ModalFooter>
            <Button
              mr={3}
              borderColor="#000"
              color="#000"
              border="3px solid"
              bg="white"
              onClick={onClose}
              padding="0.5rem 1rem"
              transition="0.2s ease"
              _hover={{
                background: '#fff',
                filter: 'brightness(0.8)',
              }}
            >
              Não
            </Button>
            <Button
              color="#fff"
              padding="0.5rem 1rem"
              bg={!demand?.status ? colors.brand.green500 : colors.brand.red200}
              transition="0.2s ease"
              _hover={{
                background: !demand?.status ? colors.brand.green500 : colors.brand.red200,
                filter: 'brightness(0.8)',
              }}
              onClick={() => handleUpdateStatus(demand)}
            >
              {demand?.status ? 'Sim, quero inativar' : 'Sim, quero ativar'}
            </Button>
          </ModalFooter>
          <ModalCloseButton />
        </ModalContent>
      </Modal>
    </>
  );
};

export const ModalChangeStatus = React.memo(ComponentModalChangeStatus);
